import { Box, IconButton, Tooltip } from "@mui/material";
import React from "react";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import { MdPowerSettingsNew } from "react-icons/md";
import AddCircleIcon from "@mui/icons-material/AddCircle";
export const ColumnButton = (props) => {
  return (
    <Box>
      {props.type === "edit" ? (
        <Tooltip title="Edit">
          <IconButton color="warning" onClick={props?.onClick}>
            <AiOutlineEdit />
          </IconButton>
        </Tooltip>
      ) : props.type === "delete" ? (
        <Tooltip title="Delete">
          <IconButton color="error" onClick={props?.onClick}>
            <AiOutlineDelete />
          </IconButton>
        </Tooltip>
      ) : props.type === "loading" ? (
        <Tooltip title="Loading">
          <IconButton color="warning" onClick={props?.onClick}>
            <HourglassBottomIcon />
          </IconButton>
        </Tooltip>
      ) : props.type === "activate" ? (
        <Tooltip title={props.is_active ? "Deactivate" : "Activate"}>
          <IconButton
            color={props.is_active ? "error" : "success"}
            onClick={props?.onClick}
          >
            {props.is_active ? (
              <MdPowerSettingsNew color={"success"} />
            ) : (
              <MdPowerSettingsNew color={"error"} />
            )}
          </IconButton>
        </Tooltip>
      ) : props.type === "add" ? (
        <Tooltip title="Add">
          <IconButton color={"primary"} onClick={props?.onClick}>
            <AddCircleIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title={props.title}>
          <IconButton color={props.color} onClick={props?.onClick}>
            {props.icon}
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};
